// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rs95","controls":"styles_controls__39LCQ","charLimit":"styles_charLimit__43wXM","input":"styles_input__1B5vh","send":"styles_send__3jFTy"};